import { Pencil } from "lucide-react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap"
import { useDispatch } from "react-redux"

import Paginations from "components/Common/Pagination"
import AddCandidatesModal from "../Candidates/AddCandidatesModal"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import EditAttendanceModal from "./EditAttendanceModal"

const headers = [
  "S. No.",
  "Name",
  "National Id",
  "Phone Number",
  "Shift",
  "Station",
  "Check In Station",
  "Check In At",
  "Check In By",
  "Check Out Station",
  "Check Out At",
  "Check Out By",
  "Checked At",
  "Remarks",
  "Action",
]

const AttendanceTable = ({
  onPageChange,
  data,
  currentPage,
  perPage,
  totalPages,
  totalCount,
  trigger,
  showAll,
  permissions,
}) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(null)
  const [expandedRowId, setExpandedRowId] = useState(null)
  const [selectedAttendance, setSelectedAttendance] = useState(null)

  return (
    <>
      <Card className="overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      style={
                        header === "Title"
                          ? { minWidth: "165px", whiteSpace: "nowrap" }
                          : header === "Start Date" || header === "End Date"
                          ? { minWidth: "99px", whiteSpace: "nowrap" }
                          : undefined
                      }
                    >
                      {t(header)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length > 0 &&
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <th scope="row">
                        {(currentPage - 1) * perPage + index + 1}
                      </th>
                      <td>
                        <p>{item.user.name}</p>
                      </td>
                      <td>{item.user.national_id}</td>
                      <td>{item.user.phone}</td>
                      <td>{item.shift}</td>
                      <td>{item.station}</td>
                      <td>{item.check_in_station || "-"}</td>
                      <td>{item.checkin_at || "-"}</td>
                      <td>{item.check_in_by || "-"}</td>
                      <td>{item.checkout_station || "-"}</td>
                      <td>{item.checkout_at || "-"}</td>
                      <td>{item.checkout_by || "-"}</td>
                      <td>{item.checked_at || "-"}</td>
                      <td
                        onClick={() =>
                          setExpandedRowId(
                            expandedRowId === item.id ? null : item.id
                          )
                        }
                        style={{
                          maxWidth: "150px",
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace:
                            expandedRowId === item.id ? "normal" : "nowrap",
                          wordBreak: "break-word",
                        }}
                        title={t("Click to expand")}
                      >
                        {item.remarks || "-"}
                      </td>
                      <td>
                        <div className="d-flex gap-2 action_buttons">
                          {(showAll ||
                            permissions.includes("can_edit_attendance")) && (
                            <Button
                              color="secondary"
                              onClick={() => {
                                setSelectedAttendance(item)
                                setIsOpen(true)
                              }}
                              title={t("Update")}
                            >
                              <Pencil />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      {data.length === 0 && <NoDataAvailable />}
      {data.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}

      {isOpen && (
        <EditAttendanceModal
          isOpen={isOpen}
          toggle={() => {
            setIsOpen(false)
            setSelectedAttendance(null)
            trigger()
          }}
          attendanceDetails={selectedAttendance}
        />
      )}
    </>
  )
}

export default AttendanceTable
